/**
 * Adds fragments to redirect URL in login anchors.
 */
export default class LoginRedirectFragment {
	/**
	 * Constructor.
	 *
	 * @param {HTMLAnchorElement} link The login anchor.
	 */
	constructor( link ) {
		this.link = link;
		if ( link.href.indexOf( '#' ) !== -1 ) {
			return;
		}
		this.originalHref = link.href;
		window.addEventListener(
			'hashchange',
			this.setHash.bind( this )
		);
		this.setHash();
	}

	/**
	 * Sets the hash of the anchor.
	 */
	setHash() {
		this.link.href = this.originalHref;
		var hash = window.location.hash;
		if ( hash.length ) {
			this.link.href += encodeURIComponent( hash );
		}
	}
};
